module.exports = __webpack_public_path__ + "static/Quicksand-Regular-216d43ee8707910af457af569eda1dec.ttf";